<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <corporations></corporations>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Corporations from './Corporations/Corporations.vue'

  export default {
    components: {
      Corporations
    }
  }

</script>
<style>

</style>
